import './Testimonials.css'
import React from 'react'

import Slider from './Slider'

export default ({ title, testimonial, background }) =>
    <section className={`testimonials bg-${background}`}>
        <div className='container'>
            {title && <h2>{title}</h2>}
        </div>
        <Slider
            slides={testimonial}
        />
    </section>


// WEBPACK FOOTER //
// ./src/components/Testimonials.js